<template>
  <div class="mobile-home">
    <div class="case-content">
      <div class="title-content">
        <div
          class="big-title"
          @click="goRouterPath('/mobile/case')"
        >
          {{ $t("route.case") }}
        </div>
        <div class="small-title">Customer Case</div>
      </div>
      <div class="case-img-content">
        <div
          :key="index"
          v-for="(item, index) in customerCaseList"
          class="case-img-item"
          @click="getDetail(item, 'case')"
        >
          <div class="case-img">
            <img
              :src="item.mainPicture"
              alt=""
            />
          </div>
          <div class="case-text">{{ item.caseName }}</div>
        </div>
      </div>
    </div>
    <div class="product-content">
      <div class="title-content">
        <div
          class="big-title"
          @click="goRouterPath('/mobile/product')"
        >
          {{ $t("route.product") }}
        </div>
        <div class="small-title">Product service</div>
      </div>
      <div class="product-select-content">
        <div class="select-item">
          <div
            class="select-item-header-content"
            @click="goRouterPath('/mobile/product', 'one')"
          >
            <span>{{ $t("product.product_introduce") }}</span>
            <!-- <img src="../../assets/mobile/arrow.png" alt="" /> -->
          </div>
          <div class="home-product-img-content">
            <div
              class="img-content"
              :class="{ 'no-margin-left': (index + 1) % 3 === 1 }"
              :key="item.id"
              v-for="(item, index) in productList"
              @click="getDetail(item, 'product')"
            >
              <img
                :src="item.mainPicture"
                alt=""
              />
              <span>{{ item.productName }}</span>
            </div>
          </div>
          <div
            class="check-more-product"
            @click="goRouterPath('/mobile/product', 'one')"
          >
            {{ $t("product.more_product") }}
          </div>
        </div>
        <div class="select-item">
          <div
            class="select-item-header-content"
            @click="goRouterPath('/mobile/product', 'two')"
          >
            <span>{{ $t("product.platform") }}</span>
            <img
              src="../../assets/mobile/arrow.png"
              alt=""
            />
          </div>
        </div>
        <div class="select-item">
          <div
            class="select-item-header-content"
            @click="goRouterPath('/mobile/product', 'three')"
          >
            <span>{{ $t("product.tutorial") }}</span>
            <img
              src="../../assets/mobile/arrow.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="news-content">
      <div class="title-content">
        <div
          class="big-title"
          @click="goRouterPath('/mobile/news')"
        >
          {{ $t("route.news") }}
        </div>
        <div class="small-title">Industry News</div>
      </div>
      <div class="news-select-content">
        <div
          :key="item.id"
          v-for="item in newsList"
          @click="getDetail(item, 'news')"
          class="news-item"
        >
          <div class="news-item-time">
            <span class="time-day">{{ item.date[2] }}</span>
            <span class="time-year-month">{{ item.date[0]
              }}<span v-if="$i18n.locale === 'zh'">{{ $t("news.year") }}</span>/{{ item.date[1]
              }}<span v-if="$i18n.locale === 'zh'">{{
                $t("news.month")
              }}</span></span>
          </div>
          <div class="news-item-text">{{ item.title }}</div>
          <div class="news-item-img">
            <img :src="item.thumbnails" />
          </div>
        </div>
      </div>
    </div>
    <div class="aboutus-content">
      <div class="title-content">
        <div
          class="big-title"
          @click="goRouterPath('/mobile/aboutus')"
        >
          {{ $t("route.aboutus") }}
        </div>
        <div class="small-title">About us</div>
      </div>
      <div class="aboutus-logo">
        <img src="../../assets/mobile/logo.png" />
      </div>
      <div class="aboutus-text">
        <div class="home-phone-img-box">
          <img
            src="../../assets/mobile/HomePhone.png"
            alt=""
          />
          <span class="home-phone-text">{{ $t("home.telephone")
            }}<a
              @click="businessStatisClick()"
              style="color: white"
              href="tel:020-85532423"
            >020-85532423</a></span>
        </div>
        <span>{{ $t("home.guangzhou_headquarters") }}{{ $t("home.guangzhou_headquarters_content") }}</span>
      </div>
      <div class="aboutus-notes">
        UYU.CN {{ $t("settings.title") }}2003-2021 ALL RIGHTS RESERVED.
        {{ $t("settings.recordnumber") }}
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/axios/index.js";
export default {
  name: "home",
  props: {
    msg: String,
  },
  data() {
    return {
      params: {
        page: 1,
        pageSize: 15,
        orders: { sequence: "desc" },
        param: {
          lang: "zh_CN",
        },
      },
      customerCaseList: [],
      newsList: [],
      productList: [],
    };
  },
  created() {
    if (this.$i18n.locale === "zh") {
      this.params.param.lang = "zh_CN";
    } else if (this.$i18n.locale === "en") {
      this.params.param.lang = "en";
    }
    this.getHomePageList();
  },
  methods: {
    businessStatisClick(){
      this.businessStatis('phoneData')
    },
    // 跳转到对应模块详情页
    getDetail(item, type) {
      switch (type) {
        case "case":
          this.$router.push({
            path: "/mobile/case/detail",
            query: {
              id: item.id,
            },
          });
          break;
        case "news":
          this.$router.push({
            name: "mobile-news-detail",
            params: item,
          });
          break;
        case "product":
          this.$router.push({
            name: "mobile-product-detail",
            params: item,
            query:{
              productId:item.id
            }
          });
          break;
        default:
          break;
      }
    },
    // 首页跳转到对应模块
    goRouterPath(path, type = null) {
      if (type) {
        this.$router.push({
          path: path,
          query: {
            type: type,
          },
        });
        return;
      }
      this.$router.push(path);
    },
    // 刷新首页数据
    getHomePageList() {
      this.getNewsList();
      this.getCustomerCaseList();
      this.getProductList();
    },
    // 获取U鱼产品列表
    getProductList() {
      this.customerCaseList = [];
      const url = `/frontProductDescription/${this.params.param.lang}`;
      http
        .get(url)
        .then((res) => {
          if (res.code === "00000") {
            this.productList = res.data.splice(0, 6);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 获取客户案例列表
    getCustomerCaseList() {
      this.customerCaseList = [];
      const url = `/frontCustomerCase/page`;
      http
        .post(url, this.params)
        .then((res) => {
          if (res.code === "00000") {
            this.customerCaseList = res.data.list.splice(0, 4);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 获取行业新闻列表内容
    getNewsList() {
      this.newsList = [];
      const url = `/frontIndustryNews/${this.params.param.lang}`;
      http
        .get(url)
        .then((res) => {
          if (res.code === "00000") {
            // 首页截取
            res.data = res.data.slice(0, 3);
            res.data.forEach((item) => {
              let arr = item.releaseTime.split("-");
              item.date = [arr[0], arr[1], arr[2]];
            });
            this.newsList = res.data;
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  watch: {
    "$i18n.locale"(newValue) {
      if (newValue === "zh") {
        this.params.param.lang = "zh_CN";
      } else {
        this.params.param.lang = "en";
      }
      this.customerCaseList = [];
      this.getHomePageList();
    },
  },
};
</script>
<style lang="less" scoped>
.mobile-home {
  .case-content {
    box-sizing: border-box;
    overflow: scroll;
    .title-content {
      padding-top: 7rem;
      padding-bottom: 7rem;
      text-align: center;
      .big-title {
        font-size: 4.2rem;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #2b2b2b;
      }

      .small-title {
        font-size: 2.4rem;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #1ea5ff;
      }
    }
    .case-img-content {
      overflow: scroll;
      box-sizing: border-box;
      padding: 0 4rem 4rem 4rem;

      .case-img-item {
        width: 31.2rem;
        display: inline-flex;
        flex-direction: column;
        box-sizing: border-box;
        overflow: hidden;
        &:nth-child(2n) {
          margin-left: 4.6rem;
        }
        &:nth-child(1n + 1) {
          margin-top: 4.6rem;
        }
        &:nth-child(1) {
          margin-top: unset;
        }
        &:nth-child(2) {
          margin-top: unset;
        }
        .case-img {
          overflow: hidden;
          width: 30rem;
          height: 20rem;
          background: #ffffff;
          border-radius: 0.6rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .case-text {
          width: 100%;
          margin-top: 1.4rem;
          text-align: center;
          font-size: 2.4rem;
        }
      }
    }
  }
  .product-content {
    box-sizing: border-box;
    overflow: scroll;
    background: #f5f5f5;
    .title-content {
      padding-top: 7rem;
      padding-bottom: 2rem;
      text-align: center;
      .big-title {
        font-size: 4.2rem;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #2b2b2b;
      }

      .small-title {
        font-size: 2.4rem;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #1ea5ff;
      }
    }
    .product-select-content {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      flex-direction: column;
      background: #f5f5f5;
      .select-item {
        width: 68.4rem;
        border-bottom: 1px solid #cbcbcb;
        padding: 4rem 0;
        box-sizing: border-box;
        font-size: 3.6rem;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #a3a3a3;
        &:last-child {
          border-bottom: unset;
        }
        .select-item-header-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        span {
          margin: auto;
        }
        img {
          width: 2rem;
          height: 1.2rem;
          // transform: rotate(270deg);
        }
        .home-product-img-content {
          width: 100%;
          box-sizing: border-box;
          display: inline-flex;
          flex-wrap: wrap;
          border-radius: 2rem;
          overflow: hidden;
          .img-content {
            margin-top: 3.8rem;
            width: 21.2rem;
            border-radius: 2rem;
            margin-left: 1.8rem;
            display: flex;
            flex-direction: column;
            img {
              width: 21.2rem;
              height: auto;
              // min-height: 16rem;
              // max-height: 16rem;
              border-radius: 2rem;
              // width: 100%;
              // height: 100%;
            }
            span {
              text-align: center;
              box-sizing: border-box;
              display: inline-block;
              margin: 2.6rem 0 0 0 !important;
              font-size: 2rem;
              font-family: Alibaba PuHuiTi;
              font-weight: 400;
              color: #a3a3a3;
            }
          }
          .no-margin-left {
            margin-left: unset;
          }
        }
        .check-more-product {
          margin: 4rem auto 0 auto;
          width: 30.4rem;
          height: 5.4rem;
          text-align: center;
          line-height: 5.4rem;
          background: #1ea5ff;
          border-radius: 2.6rem;
          font-size: 2.6rem;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #fffefe;
        }
      }
    }
  }
  .news-content {
    box-sizing: border-box;
    overflow: scroll;
    .title-content {
      padding-top: 7rem;
      padding-bottom: 2rem;
      text-align: center;
      .big-title {
        font-size: 4.2rem;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #2b2b2b;
      }

      .small-title {
        font-size: 2.4rem;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #1ea5ff;
      }
    }
    .news-select-content {
      .news-item {
        display: flex;
        justify-content: space-between;
        // align-items: center;
        box-sizing: border-box;
        overflow: hidden;
        padding: 3rem 0 3rem 0;
        margin: 0 4rem;
        border-bottom: 1px solid #eeeeee;
        &:first-child {
          padding-top: unset;
        }
        &:last-child {
          border-bottom: unset;
        }

        .news-item-time {
          text-align: center;
          display: flex;
          flex-direction: column;
          color: #09a7f5;
          .time-day {
            white-space: nowrap;
            font-size: 10rem;
            font-family: Alibaba PuHuiTi;
            font-weight: 500;
            line-height: 8rem;
          }
          .time-year-month {
            white-space: nowrap;
            font-size: 2rem;
            font-family: Alibaba PuHuiTi;
            font-weight: 500;
          }
        }
        .news-item-text {
          width: 31.2rem;
          font-size: 2.8rem;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #2b2b2b;
        }
        .news-item-img {
          width: 17.6rem;
          height: 11.4rem;
          border-radius: 2rem;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .aboutus-content {
    box-sizing: border-box;
    overflow: scroll;
    background: #f5f5f5;
    .title-content {
      padding-top: 7rem;
      padding-bottom: 2rem;
      text-align: center;
      .big-title {
        font-size: 4.2rem;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #2b2b2b;
      }

      .small-title {
        font-size: 2.4rem;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #1ea5ff;
      }
    }
    .aboutus-logo {
      margin: auto;
      width: 12.6rem;
      height: 12.6rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .aboutus-text {
      display: flex;
      flex-direction: column;
      padding-left: 8rem;
      padding-right: 8rem;
      // align-items: center;
      box-sizing: border-box;
      padding-top: 2rem;
      font-size: 2.6rem;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #353535;
      text-align: center;
      .home-phone-img-box {
        position: relative;
        margin: 0 auto;
        width: 43.4rem;
        img {
          width: 100%;
        }
        .home-phone-text {
          left: 9rem;
          top: 0.5rem;
          position: absolute;
          color: white;
          font-size: 2.6rem;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #ffffff;
        }
      }
      span {
        margin-top: 1rem;
        &:first-child {
          margin-top: unset;
        }
      }
    }
    .aboutus-notes {
      width: 53.8rem;
      text-align: center;
      margin: 6rem auto;
      font-size: 2.4rem;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #b1b1b1;
    }
  }
}
</style>
